import { debounce } from "lodash";
import React, { useState, useMemo } from 'react';

const DebouncedSearchInput = ({
  onSearch,
  className = "form-control",
  placeholder = "Search...",
  delay = 500
}) => {
  const [query, setQuery] = useState('');

  // Memoize the debounced search function
  const debouncedSearch = useMemo(() =>
    debounce((value) => {
      onSearch(value);
    }, delay), [onSearch]);

  const handleChange = (e) => {
    const value = e.target.value;
    setQuery(value);
    debouncedSearch(value);
  };

  const handleClear = () => {
    setQuery('');
    debouncedSearch(''); // Clear the search
  };

  return (
    <div className="position-relative">
      <input
        className={className}
        type="text"
        value={query}
        onChange={handleChange}
        placeholder={placeholder}
        style={{ paddingRight: '2.5rem' }} // Space for the clear button
      />
      {query && (
        <button
          type="button"
          onClick={handleClear}
          style={{
            position: 'absolute',
            right: '0.5rem',
            top: '50%',
            transform: 'translateY(-50%)',
            border: 'none',
            background: 'transparent',
            cursor: 'pointer',
            fontSize: '1.2rem',
            lineHeight: 1,
            color: '#888'
          }}
          aria-label="Clear search"
        >
          &times;
        </button>
      )}
    </div>
  );
};

export default DebouncedSearchInput;
